import { Component } from '@angular/core';
import { A3Service } from '../../../services/a3/a3.service';
import { A3EnlaceContableRequest } from '../../../models/a3/a3.model';
import * as FileSaver from 'file-saver';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Utils } from '../../../shared/utils';
import { consts } from '../../../consts';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'convfact-user-export',
    templateUrl: './user-export.component.html',
    styleUrls: [],
    standalone: false
})
export class UserExportComponent {

  public request: A3EnlaceContableRequest = {
    from: new Date(),
    to: new Date(),
    companyCode: '',
  };

  public loadingRequest: boolean = false;

  public typeInformation: string = 'InvoiceIssued';

  public typeInformationOptions: Option[] = [
    { label: 'Facturas emitidas', value: 'InvoiceIssued' },
    { label: 'Facturas recibidas', value: 'InvoiceReceived' },
    { label: 'Pagos/Cobros ( Facturas emitidas/recibidas)', value: 'Deposits' },
  ];

  constructor(
    public a3Service: A3Service,
    public snackBar: MatSnackBar,
  ) { }

  public download(): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    if (this.typeInformation === 'InvoiceIssued') {
      this.exportInvoiceIssued();
    }

    if (this.typeInformation === 'InvoiceReceived') {
      this.exportInvoiceReceived();
    }

    if (this.typeInformation === 'Deposits') {
      this.exportDeposits();
    }
  }

  public exportInvoiceReceived(): void {
    this.loadingRequest = true;

    this.a3Service.getA3SuenlaceInvoiceReceived(this.request)
      .subscribe(response => {
        FileSaver.saveAs(response, 'SUENLACE.DAT');
        this.loadingRequest = false;
      }, error => {
        this.displayInfo('Ha ocurrido un error al generar el fichero');
      });
  }

  public exportInvoiceIssued(): void {
    this.loadingRequest = true;

    this.a3Service.getA3SuenlaceInvoiceIssued(this.request)
      .subscribe(response => {
        FileSaver.saveAs(response, 'SUENLACE.DAT');
        this.loadingRequest = false;
      }, error => {
        this.displayInfo('Ha ocurrido un error al generar el fichero');
      });
  }

  public exportDeposits(): void {
    this.loadingRequest = true;

    this.a3Service.getA3SuenlaceDeposits(this.request)
      .subscribe(response => {
        FileSaver.saveAs(response, 'SUENLACE.DAT');
        this.loadingRequest = false;
      }, error => {
        this.displayInfo('Ha ocurrido un error al generar el fichero');
      });

  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 3000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

}
